import { AuthenticationService } from '@/api/services/Authentication/CheckToken';
import { useServiceInstance } from '@/hooks/useServiceInstance';

import { useServiceMethod } from '../useServiceMethod';

export function useCheckToken() {
  const service = useServiceInstance(AuthenticationService);
  return useServiceMethod(service.execute);
}
